module.exports = __webpack_public_path__ + "static/img/box-bg3.b9a0525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/box-bg3.png
// module id = uKgy
// module chunks = 0